<template>
    <div>
        <div v-show="menuOpen" @click="menuOpen=false" class="fade-screen"></div>
        <progress-bar></progress-bar>
        <loader />
        <div v-show="$root.user.loaded" class="page-header">
            <app-top @toggle-mobile-menu="onMenuOpen" />
            <app-header-menu :menu-open="menuOpen" @close-menu="onMenuClose"/>
        </div>
        <div class="over-wrap" v-bind:class="{ 'over-flex': $route.name === 'ssp-list' }">
            <router-view :key="$route.path"/>
            <notifications position="bottom center" :max="5" animation-type="velocity" width="400px">
                <template #body="props">
                    <div v-bind:class="{
                    'alert-danger': props.item.type === 'danger',
                    'alert-warning': props.item.type === 'warning',
                    'alert-primary': props.item.type === 'primary'
                }" class="alert-dismissible">
                        <button type="button" @click="props.close" class="close">×</button>
                        {{ props.item.text }}
                    </div>
                </template>
            </notifications>
        </div>
        <app-footer v-show="$root.user.loaded" />
        <confirm-dialog ref="confirmDialog" />
        <warning-dialog ref="warningDialog" />
    </div>
</template>

<script>
import AppTop from '@/js/components/_Layouts/Top.vue'
import AppHeaderMenu from '@/js/components/_Layouts/HeaderMenu/Menu.vue'
import AppFooter from '@/js/components/_Layouts/Footer.vue'
import ProgressBar from "@/js/views/ProgressBar.vue";
import ConfirmDialog from "@/js/components/ConfirmDialog.vue";
import WarningDialog from "@/js/components/WarningDialog.vue";
import { setConfirmHandler } from '@/js/services/confirm-service';

export default {
    data: () => ({
        menuOpen: false,
        isOnline: window.navigator.onLine
    }),

    components: {
        ConfirmDialog,
        WarningDialog,
        ProgressBar,
        AppTop, AppHeaderMenu, AppFooter
    },
    created() {

    },
    mounted() {
        const confirmHandler = message => this.$refs.confirmDialog.open({ message });

        setConfirmHandler(confirmHandler);
        this.$root.$confirm = confirmHandler;
        window.addEventListener('offline', this.handleOffline);
        window.addEventListener('online', this.handleOnline);
        
    },
    beforeDestroy() {
        window.removeEventListener('offline', this.handleOffline);
        window.removeEventListener('online', this.handleOnline);
    },
    watch: {
        menuOpen: function(value) {
            if (value) {
                document.documentElement.classList.add('no-scroll');
                document.body.classList.add('no-scroll');
            } else {
                document.documentElement.classList.remove('no-scroll');
                document.body.classList.remove('no-scroll');
            }
        }
    },
    methods:  {
        onMenuOpen (event) {
          this.menuOpen = true;
        },
        onMenuClose() {
            this.menuOpen = false;
        },
        handleOffline() {
            this.isOnline = false;
            this.$refs.warningDialog.open({
                message: 'You are having trouble with the Internet connection, any actions will not be applied'
            });
        },

        handleOnline() {
            this.isOnline = true;
            this.$refs.warningDialog.open({
                message: 'Internet connection restored.'
            });
        },
    },

}
</script>
<style lang='scss'>
.alert-dismissible {
    padding: 10px;
    margin: 0 5px 5px;

    font-size: 14px;

    color: #ffffff;
    background: #44A4FC;
    border-left: 5px solid #187FE7;

    .close {
        position: relative;
        top: 0;
        right: 0;
    }

    &.alert-warning {
        color: #c29d0b;
        background: #faebb0;
        border-left-color: #c29d0b;
    }

    &.alert-danger {
        color: #e73d4a;
        background: #f2dede;
        border-left-color: #e73d4a;
    }

    &.alert-primary {
        color: #337ab7;
        background: #f8f9fa;
        border-left-color: #337ab7;
    }
}
</style>
